import React, { FormEvent } from 'react';
import { goalsPageRoute, landingPageRoute, singleGoalPageRoute } from '../../common/linkRoutes';
import GoalForm from '../../components/goal/goalForm';
import Layout from '../../components/layout/Layout';
import { GoalI } from '../../interfaces/GoalInterface';
import { useStore } from '../../store/store';
import { BasicProps } from './GoalPage';

const EditGoalPage = (props: BasicProps) => {
    const { goal, updateGoal, setRedirect, user } = useStore();


    const onEditGoal = async (event: FormEvent<HTMLFormElement>, formObj: GoalI) => {
        event.preventDefault();

        if (!user) {
            setRedirect(landingPageRoute);
        }

        updateGoal(formObj);
        setRedirect(singleGoalPageRoute);
    };

    return <Layout pageName='Set Goal' backRoute={goalsPageRoute} {...props} >
        {goal && <GoalForm initFormData={goal} onSubmit={onEditGoal} />}
    </Layout>;
};

export default EditGoalPage;